import React from 'react'

import MediaAvatar from '../../../../../atoms/MediaAvatar'

import { useUserAPI } from '../../../../../../providers/UserAPIProvider'
import useStyles from './styles'

type TextCustomFieldCellProps = {
  value: string
  customField: LocalCustomField
}

const TextCustomFieldCell: React.FC<TextCustomFieldCellProps> = ({
  value,
  customField
}) => {
  const { allUsers, loadUser } = useUserAPI()

  const selectedUser = React.useMemo(() => {
    if (customField.field_type !== 'user') {
      return null
    }

    return allUsers[value] ?? null
  }, [customField, allUsers, value])

  const displayValue = React.useMemo(() => {
    if (customField.field_type === 'multiselect') {
      if (!value) {
        return ''
      }

      return value.split('|').join(', ')
    }

    if (customField.field_type === 'boolean') {
      if (!value) {
        return ''
      }

      return value === 'true' ? 'Yes' : 'No'
    }

    if (customField.field_type === 'user') {
      return selectedUser?.name ?? ''
    }

    return value
  }, [value, customField.field_type, selectedUser])

  const classes = useStyles()

  // Load user if needed
  React.useEffect(() => {
    if (customField.field_type === 'user' && !selectedUser) {
      loadUser(value)
    }
  }, [customField, selectedUser, loadUser, value])

  return (
    <div className={classes.root}>
      {selectedUser && <MediaAvatar user={selectedUser} className='avatar' />}
      {displayValue}
    </div>
  )
}

export default TextCustomFieldCell
